import { createContext, useContext } from "react"

export type AudioPlaybackContextType = {
  /** The message ID (stanzaId) of the currently playing audio, or null */
  playingMessageId: string | null
  /** Register this message as playing. Pauses any other playing audio. */
  play: (messageId: string) => void
  /** Mark the currently playing message as stopped */
  stop: () => void
}

export const AudioPlaybackContext = createContext<AudioPlaybackContextType>({
  playingMessageId: null,
  play: () => {},
  stop: () => {},
})

export function useAudioPlayback() {
  return useContext(AudioPlaybackContext)
}
